import ReactDOM from 'react-dom/client';
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Snackbar, SnackbarProvider, Tooltip } from '@c2fo/liquidity';
import queryClient from './app/lib/queryClient';
import Router from './Router';
import './index.css';

// Set document title based on environment
const env = import.meta.env.VITE_ENV || 'local';
if (env !== 'production') {
  document.title = `Admin - ${env.toUpperCase()}`;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <div className="flex min-h-screen flex-col bg-canvas antialiased">
        <SnackbarProvider>
          <Tooltip.Provider delayDuration={0}>
            <Router />
            <ReactQueryDevtools initialIsOpen={false} position="bottom" buttonPosition="bottom-right" />
            <Snackbar vertical="bottom" horizontal="left" />
          </Tooltip.Provider>
        </SnackbarProvider>
      </div>
    </QueryClientProvider>
  </React.StrictMode>,
);
